"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTabFocus = void 0;
var react_1 = require("react");
var useTabFocus = function (size, elementRef) {
    var _a = (0, react_1.useState)(0), currentFocus = _a[0], setCurrentFocus = _a[1];
    var handleKeyDown = (0, react_1.useCallback)(function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var focusIndex = 0;
            elementRef.current
                .querySelector("[role=\"tab\"][data-index=\"".concat(currentFocus, "\"]"))
                .setAttribute('tabIndex', '-1');
            if (e.key === 'ArrowRight') {
                focusIndex = currentFocus === size - 1 ? 0 : currentFocus + 1;
            }
            else {
                focusIndex = currentFocus === 0 ? size - 1 : currentFocus - 1;
            }
            var tabElement = elementRef.current.querySelector("[role=\"tab\"][data-index=\"".concat(focusIndex, "\"]"));
            tabElement.setAttribute('tabIndex', '0');
            tabElement.focus();
            setCurrentFocus(focusIndex);
        }
    }, [size, currentFocus, setCurrentFocus, elementRef]);
    (0, react_1.useEffect)(function () {
        var element = elementRef.current;
        element === null || element === void 0 ? void 0 : element.addEventListener('keydown', handleKeyDown, false);
        return function () {
            element === null || element === void 0 ? void 0 : element.removeEventListener('keydown', handleKeyDown, false);
        };
    }, [handleKeyDown, elementRef]);
    return [currentFocus, setCurrentFocus];
};
exports.useTabFocus = useTabFocus;
